import React, { useState, useEffect, useRef, useMemo } from 'react';
import MaterialTable from 'material-table';
import TableIcons from '../components/TableIcons';
import { tableOptions } from '../components/TableDefaults';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { makeStyles } from '@mui/styles';
import { useTranslation } from "react-i18next";
import {
  Modal,
  Grid,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Chip,
  Menu,
  MenuItem,
  IconButton,
} from '@mui/material';
import Button from "components/CustomButtons/Button.js";
import CancelIcon from '@mui/icons-material/Cancel';
import AlertDialog from '../components/AlertDialog';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import BlockIcon from '@mui/icons-material/Block';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {colors} from '../components/Theme/WebTheme';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submit3:{
    width:'100%',
    borderRadius: 12,
    marginTop: 8,
    padding: '12px 24px',
    fontWeight: 600,
    textTransform: 'none',
  },
  paper: {
    width: 500,
    maxWidth: '95vw',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    padding: theme.spacing(3),
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
    flexWrap: 'wrap',
    gap: 16,
  },
  pageTitle: {
    fontWeight: 700,
    color: colors.DARK,
    fontSize: '1.5rem',
  },
}));

export default function CarsList() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const {
    updateUserCar,
    editCar
  } = api;
  const [driversObj, setDriversObj] = useState();
  const [fleetMapObj, setFleetMapObj] = useState([]);
  const [data, setData] = useState([]);
  const carlistdata = useSelector(state => state.carlistdata);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [role, setRole] = useState(null);
  
  useEffect(() => {
    if(role !== 'driver' && userdata.users){
        let arr =  userdata.users.filter(user => user.usertype==='driver' && ((role === 'fleetadmin' && user.fleetadmin && user.fleetadmin === auth.profile.uid) || role === 'admin'));
        let obj = {}; 
        let obj2 =  {};
        for(let i=0;i  < arr.length; i++){
            let user = arr[i];
            obj[user.id]=user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden");
            obj2[user.id]=user.fleetadmin?user.fleetadmin:null
        }
        setDriversObj(obj);
        setFleetMapObj(obj2);    
    } 
  }, [userdata.users,settings.AllowCriticalEditsAdmin,role,auth.profile.uid]);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata.cars) {
      setData(carlistdata.cars)
    } else {
      setData([]);
    }
  }, [carlistdata.cars]);

  const [selectedImage, setSelectedImage] = useState(null); 
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  }

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] =  useState(false);
  const [imageData, setImageData] =  useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [loading, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleSetProfileModal = (e) =>{
    e.preventDefault();
    if(selectedImage){
      setLoading(true);
      let finalData = userData;
      finalData.car_image = selectedImage;
      dispatch(editCar(finalData, "UpdateImage"));
      setProfileModal(false); 
      setTimeout(()=>{
        setSelectedImage(null);
        setLoading(false); 
      },10000);
    }
    else{
      setCommonAlert({ open: true, msg: t('choose_image_first') })
    }
  }

  const onClick = (rowData) => {
    setImageData(rowData.car_image);
    setProfileModal(true);
    setUserData(rowData);
  };
  
  // Custom 5-column definition
  const columns = [
    {
      title: t('vehicle_reg_no'),
      field: 'vehicleNumber',
      render: rowData => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {rowData.car_image ? (
            <Box
              component="button"
              onClick={(e) => { e.stopPropagation(); onClick(rowData); }}
              sx={{
                width: 48, height: 48, borderRadius: 2, overflow: 'hidden',
                border: '2px solid #F3F4F6', cursor: 'pointer', p: 0, bgcolor: 'transparent'
              }}
            >
              <img alt='Car' src={rowData.car_image} style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
            </Box>
          ) : (
            <Box sx={{ width: 48, height: 48, borderRadius: 2, bgcolor: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <DirectionsCarIcon sx={{ color: '#9CA3AF', fontSize: 24 }} />
            </Box>
          )}
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>
              {rowData.vehicleNumber || '-'}
            </Typography>
            <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
              {rowData.carType || '-'}
            </Typography>
          </Box>
        </Box>
      ),
      cellStyle: { padding: '12px 16px' },
      editable: 'never',
    },
    {
      title: t('driver'),
      field: 'driver',
      render: rowData => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 32, height: 32, borderRadius: '50%', bgcolor: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <PersonIcon sx={{ fontSize: 16, color: '#6366F1' }} />
          </Box>
          <Typography sx={{ fontSize: 14, color: '#374151' }}>
            {rowData && rowData.driver && driversObj && driversObj[rowData.driver]
              ? driversObj[rowData.driver].split('(')[0].trim()
              : '-'}
          </Typography>
        </Box>
      ),
      hidden: role === 'driver',
      cellStyle: { padding: '12px 16px' },
      editable: 'never',
    },
    {
      title: t('vehicle_model_name'),
      field: 'vehicleMake',
      render: rowData => (
        <Typography sx={{ fontSize: 14, color: '#374151' }}>
          {rowData.vehicleMake || '-'} {rowData.vehicleModel || ''}
        </Typography>
      ),
      cellStyle: { padding: '12px 16px' },
      editable: 'never',
    },
    {
      title: t('status'),
      field: 'active',
      render: rowData => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <FiberManualRecordIcon sx={{ fontSize: 10, color: rowData.active ? '#10B981' : '#9CA3AF' }} />
          <Typography sx={{ fontSize: 14, color: '#374151' }}>
            {rowData.active ? (t('active') || 'Active') : (t('inactive') || 'Inactive')}
          </Typography>
        </Box>
      ),
      cellStyle: { padding: '12px 16px' },
      editable: 'never',
    },
    {
      title: t('approved'),
      field: 'approved',
      render: rowData => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <FiberManualRecordIcon sx={{ fontSize: 10, color: rowData.approved ? '#10B981' : '#F59E0B' }} />
          <Typography sx={{ fontSize: 14, color: '#374151' }}>
            {rowData.approved ? (t('approved') || 'Approved') : (t('pending') || 'Pending')}
          </Typography>
        </Box>
      ),
      cellStyle: { padding: '12px 16px' },
      editable: 'never',
    },
  ];

  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterActive, setFilterActive] = useState('all');
  const [filterApproved, setFilterApproved] = useState('all');
  const [activeAnchor, setActiveAnchor] = useState(null);
  const [approvedAnchor, setApprovedAnchor] = useState(null);

  // Filtered data
  const filteredData = useMemo(() => {
    let result = data;
    if (filterActive !== 'all') {
      result = result.filter(d => filterActive === 'active' ? d.active : !d.active);
    }
    if (filterApproved !== 'all') {
      result = result.filter(d => filterApproved === 'approved' ? d.approved : !d.approved);
    }
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      result = result.filter(d =>
        (d.vehicleNumber && d.vehicleNumber.toLowerCase().includes(query)) ||
        (d.vehicleMake && d.vehicleMake.toLowerCase().includes(query)) ||
        (d.vehicleModel && d.vehicleModel.toLowerCase().includes(query)) ||
        (d.carType && d.carType.toLowerCase().includes(query)) ||
        (d.driver && driversObj && driversObj[d.driver] && driversObj[d.driver].toLowerCase().includes(query))
      );
    }
    return result;
  }, [data, filterActive, filterApproved, searchQuery, driversObj]);

  const clearFilters = () => {
    setFilterActive('all');
    setFilterApproved('all');
    setSearchQuery('');
  };

  return (
    carlistdata.loading ? <CircularLoading /> :
    <div ref={rootRef}>
      {/* Uber-Style Filter Toolbar */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1.5,
          p: 2,
          mb: 2,
          bgcolor: '#FFFFFF',
          borderRadius: 3,
          border: '1px solid #E5E7EB',
          alignItems: 'center',
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        }}
      >
        <TextField
          size="small"
          placeholder={t('search') || 'Search vehicles...'}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{
            minWidth: 220,
            '& .MuiOutlinedInput-root': {
              borderRadius: 50,
              bgcolor: '#F7F7F7',
              '& fieldset': { border: 'none' },
              '&:hover': { bgcolor: '#EFEFEF' },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#6B7280', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ width: 1, height: 24, bgcolor: '#E5E7EB', mx: 1 }} />
        <Chip
          label={t('all') || 'All'}
          onClick={clearFilters}
          sx={{
            bgcolor: filterActive === 'all' && filterApproved === 'all' ? '#111827' : '#F7F7F7',
            color: filterActive === 'all' && filterApproved === 'all' ? '#FFFFFF' : '#374151',
            fontWeight: 500,
            fontSize: 13,
            height: 36,
            borderRadius: 50,
            px: 1,
            cursor: 'pointer',
            '&:hover': { bgcolor: filterActive === 'all' && filterApproved === 'all' ? '#000000' : '#EFEFEF' },
          }}
        />
        <Chip
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {filterActive !== 'all' && (
                <FiberManualRecordIcon sx={{ fontSize: 8, color: filterActive === 'active' ? '#10B981' : '#9CA3AF' }} />
              )}
              {filterActive === 'all' ? (t('active_status') || 'Status') : filterActive === 'active' ? (t('active') || 'Active') : (t('inactive') || 'Inactive')}
              <ExpandMoreIcon sx={{ fontSize: 16, ml: 0.5 }} />
            </Box>
          }
          onClick={(e) => setActiveAnchor(e.currentTarget)}
          sx={{
            bgcolor: filterActive !== 'all' ? '#111827' : '#F7F7F7',
            color: filterActive !== 'all' ? '#FFFFFF' : '#374151',
            fontWeight: 500,
            fontSize: 13,
            height: 36,
            borderRadius: 50,
            px: 1,
            cursor: 'pointer',
            '&:hover': { bgcolor: filterActive !== 'all' ? '#000000' : '#EFEFEF' },
          }}
        />
        <Menu
          anchorEl={activeAnchor}
          open={Boolean(activeAnchor)}
          onClose={() => setActiveAnchor(null)}
          PaperProps={{ sx: { borderRadius: 2, mt: 1, minWidth: 150, boxShadow: '0 4px 20px rgba(0,0,0,0.15)' } }}
        >
          <MenuItem onClick={() => { setFilterActive('all'); setActiveAnchor(null); }}>
            <Typography sx={{ fontSize: 14 }}>{t('all') || 'All'}</Typography>
          </MenuItem>
          <MenuItem onClick={() => { setFilterActive('active'); setActiveAnchor(null); }}>
            <FiberManualRecordIcon sx={{ fontSize: 10, color: '#10B981', mr: 1 }} />
            <Typography sx={{ fontSize: 14 }}>{t('active') || 'Active'}</Typography>
          </MenuItem>
          <MenuItem onClick={() => { setFilterActive('inactive'); setActiveAnchor(null); }}>
            <FiberManualRecordIcon sx={{ fontSize: 10, color: '#9CA3AF', mr: 1 }} />
            <Typography sx={{ fontSize: 14 }}>{t('inactive') || 'Inactive'}</Typography>
          </MenuItem>
        </Menu>
        <Chip
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {filterApproved !== 'all' && (
                <FiberManualRecordIcon sx={{ fontSize: 8, color: filterApproved === 'approved' ? '#10B981' : '#F59E0B' }} />
              )}
              {filterApproved === 'all' ? (t('approved') || 'Approved') : filterApproved === 'approved' ? (t('approved') || 'Approved') : (t('pending') || 'Pending')}
              <ExpandMoreIcon sx={{ fontSize: 16, ml: 0.5 }} />
            </Box>
          }
          onClick={(e) => setApprovedAnchor(e.currentTarget)}
          sx={{
            bgcolor: filterApproved !== 'all' ? '#111827' : '#F7F7F7',
            color: filterApproved !== 'all' ? '#FFFFFF' : '#374151',
            fontWeight: 500,
            fontSize: 13,
            height: 36,
            borderRadius: 50,
            px: 1,
            cursor: 'pointer',
            '&:hover': { bgcolor: filterApproved !== 'all' ? '#000000' : '#EFEFEF' },
          }}
        />
        <Menu
          anchorEl={approvedAnchor}
          open={Boolean(approvedAnchor)}
          onClose={() => setApprovedAnchor(null)}
          PaperProps={{ sx: { borderRadius: 2, mt: 1, minWidth: 150, boxShadow: '0 4px 20px rgba(0,0,0,0.15)' } }}
        >
          <MenuItem onClick={() => { setFilterApproved('all'); setApprovedAnchor(null); }}>
            <Typography sx={{ fontSize: 14 }}>{t('all') || 'All'}</Typography>
          </MenuItem>
          <MenuItem onClick={() => { setFilterApproved('approved'); setApprovedAnchor(null); }}>
            <FiberManualRecordIcon sx={{ fontSize: 10, color: '#10B981', mr: 1 }} />
            <Typography sx={{ fontSize: 14 }}>{t('approved') || 'Approved'}</Typography>
          </MenuItem>
          <MenuItem onClick={() => { setFilterApproved('pending'); setApprovedAnchor(null); }}>
            <FiberManualRecordIcon sx={{ fontSize: 10, color: '#F59E0B', mr: 1 }} />
            <Typography sx={{ fontSize: 14 }}>{t('pending') || 'Pending'}</Typography>
          </MenuItem>
        </Menu>
        <Typography sx={{ ml: 'auto', fontSize: 13, color: '#6B7280' }}>
          {filteredData.length} {t('cars') || 'vehicles'}
        </Typography>
      </Box>

      <MaterialTable
        icons={TableIcons}
        title={null}
        columns={columns}
        style={{
          direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
          borderRadius: 12,
          boxShadow: 'none',
          border: '1px solid #E5E7EB',
          overflow: 'hidden',
        }}
        data={filteredData}
        onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        detailPanel={rowData => (
          <Box sx={{ p: 3, bgcolor: '#F9FAFB', borderTop: '1px solid #E5E7EB' }}>
            <Grid container spacing={3}>
              {/* Vehicle Details */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <DirectionsCarIcon sx={{ fontSize: 18, color: '#6366F1' }} />
                  <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>
                    {t('vehicle_details') || 'Vehicle Details'}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('vehicle_reg_no')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827', fontWeight: 600 }}>{rowData.vehicleNumber || '-'}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('car_type')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.carType || '-'}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('vehicle_model_name')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.vehicleMake || '-'}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('vehicle_model_no')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.vehicleModel || '-'}</Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Driver Info */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <PersonIcon sx={{ fontSize: 18, color: '#2563EB' }} />
                  <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>
                    {t('driver_info') || 'Driver Info'}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('driver')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827' }}>
                      {rowData.driver && driversObj && driversObj[rowData.driver]
                        ? driversObj[rowData.driver].split('(')[0].trim()
                        : '-'}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('other_info')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827', maxWidth: 150, textAlign: 'right' }}>
                      {rowData.other_info || '-'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Status Info */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <InfoIcon sx={{ fontSize: 18, color: '#16A34A' }} />
                  <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>
                    {t('status') || 'Status'}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('active_status')}</Typography>
                    <Chip
                      label={rowData.active ? (t('active') || 'Active') : (t('inactive') || 'Inactive')}
                      size="small"
                      sx={{
                        bgcolor: rowData.active ? '#DCFCE7' : '#F3F4F6',
                        color: rowData.active ? '#16A34A' : '#6B7280',
                        fontWeight: 500,
                        fontSize: 12,
                      }}
                    />
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('approved')}</Typography>
                    <Chip
                      label={rowData.approved ? (t('approved') || 'Approved') : (t('pending') || 'Pending')}
                      size="small"
                      sx={{
                        bgcolor: rowData.approved ? '#DCFCE7' : '#FEF3C7',
                        color: rowData.approved ? '#16A34A' : '#D97706',
                        fontWeight: 500,
                        fontSize: 12,
                      }}
                    />
                  </Box>
                </Box>
              </Grid>

              {/* Actions */}
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap', pt: 2, borderTop: '1px solid #E5E7EB' }}>
                  {settings.carApproval && role === 'admin' && (
                    <Tooltip title={rowData.approved ? t('reject') : t('accept')}>
                      <Button
                        size="sm"
                        onClick={() => {
                          if(rowData.active){
                            dispatch(updateUserCar(rowData.driver,{carApproved: !rowData.approved}));
                          }
                          dispatch(editCar({...rowData, approved: !rowData.approved},"Update"));
                        }}
                        style={{
                          backgroundColor: rowData.approved ? '#FEE2E2' : '#DCFCE7',
                          color: rowData.approved ? '#DC2626' : '#16A34A',
                          borderRadius: 8,
                          textTransform: 'none',
                          fontWeight: 500,
                        }}
                      >
                        {rowData.approved ? (
                          <><BlockIcon sx={{ fontSize: 16, mr: 0.5 }} />{t('reject')}</>
                        ) : (
                          <><CheckCircleIcon sx={{ fontSize: 16, mr: 0.5 }} />{t('accept')}</>
                        )}
                      </Button>
                    </Tooltip>
                  )}
                  <Tooltip title={t('edit')}>
                    <IconButton
                      size="small"
                      onClick={() => onClick(rowData)}
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 1.5,
                        bgcolor: '#F3F4F6',
                        '&:hover': { bgcolor: '#E5E7EB' },
                      }}
                    >
                      <EditIcon sx={{ fontSize: 16, color: '#374151' }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t('delete')}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        if (settings.AllowCriticalEditsAdmin) {
                          if(rowData.active){
                            alert(t('active_car_delete'));
                          } else if (window.confirm(t('delete_message'))) {
                            dispatch(editCar(rowData, "Delete"));
                          }
                        } else {
                          alert(t('demo_mode'));
                        }
                      }}
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 1.5,
                        bgcolor: '#FEE2E2',
                        '&:hover': { bgcolor: '#FECACA' },
                      }}
                    >
                      <DeleteIcon sx={{ fontSize: 16, color: '#DC2626' }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
        options={{
          ...tableOptions,
          search: false,
          toolbar: false,
          showTitle: false,
          exportButton: true,
          rowStyle: rowData => ({
            backgroundColor: (selectedRow === rowData.tableData.id) ? '#F3F4F6' : '#fff'
          }),
        }}
        localization={{body:{
          addTooltip: (t('add')),
          deleteTooltip: (t('delete')),
          editTooltip: (t('edit')),
          emptyDataSourceMessage: (
            (t('blank_message'))
        ),
        editRow: {
          deleteText: (t('delete_message')),
          cancelTooltip: (t('cancel')),
          saveTooltip: (t('save'))
           },
          },
          toolbar: {
            searchPlaceholder: (t('search')),
            exportTitle: (t('export')),
          },
          header: {
            actions: (t('actions'))
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          //labelRowsSelect: (t('rows')),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
        }}
        editable={{
          onRowAdd: newData =>
          settings.AllowCriticalEditsAdmin?
            new Promise((resolve, reject) => {
              setTimeout(() => {
                if(newData && newData.carType && newData.vehicleNumber && newData.vehicleMake && newData.vehicleModel && newData.other_info && newData.car_image){
                  let selectDriver = role === 'admin'? newData.driver : auth.profile.uid;
                  let activeCar = null;
                  let updateData = { 
                    carType: newData.carType,
                    vehicleNumber: newData.vehicleNumber,
                    vehicleMake: newData.vehicleMake,
                    vehicleModel: newData.vehicleModel,
                    other_info: newData.other_info,
                    car_image: newData.car_image,
                    updateAt: new Date().getTime()
                  }
                  for(let i=0;i<data.length;i++){
                    if(data[i].driver === newData.driver && data[i].active){
                        activeCar = data[i];
                        break;
                    }
                  }
                  if(activeCar && newData.active){
                    activeCar.active = false;
                    dispatch(editCar(activeCar,"Update"));
                    dispatch(updateUserCar(selectDriver,updateData));
                  } else if(activeCar && !newData.active){
                    newData.active = false;           
                  }else {
                    newData.active = true;
                    dispatch(updateUserCar(selectDriver,updateData));
                  }
                  if(role === 'driver'){
                    newData['driver'] = selectDriver;
                  }
                  newData['createdAt'] = new Date().getTime();
                  newData['fleetadmin'] = newData['driver']? (fleetMapObj[newData['driver']]?fleetMapObj[newData['driver']]: null): null;
                  if(!settings.carApproval){
                    newData['approved'] = true;
                    if(newData.active){
                      dispatch(updateUserCar(newData.driver,{carApproved: true}));
                    }
                  } else {
                    newData['approved'] = false;
                  }
                  dispatch(editCar(newData,"Add"));
                  resolve();
                } else{
                  alert(t('proper_input_name'));
                  reject();
                }
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 600);
            }),
          onRowUpdate: (newData, oldData) =>
            settings.AllowCriticalEditsAdmin?
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                if(newData !== oldData){
                  let activeCar = null;
                  let updateData = { 
                    carType: newData.carType,
                    vehicleNumber: newData.vehicleNumber,
                    vehicleMake: newData.vehicleMake,
                    vehicleModel: newData.vehicleModel,
                    other_info: newData.other_info,
                    car_image: newData.car_image,
                    updateAt: new Date().getTime()
                  }
                  for(let i=0;i<data.length;i++){
                    if(data[i].driver === newData.driver && data[i].active){
                        activeCar = data[i];
                        break;
                    }
                  }
                  if(activeCar && newData.active){
                    activeCar.active = false;
                    dispatch(editCar(activeCar,"Update"));
                    dispatch(updateUserCar(newData.driver,updateData));
                  } else if(activeCar && !newData.active){
                    newData.active = false;           
                  }else {
                    newData.active = true;
                    dispatch(updateUserCar(newData.driver,updateData));
                  }
                  newData['fleetadmin'] = newData['fleetadmin']? fleetMapObj[newData['driver']]:null;
                  delete newData.tableData;
                  dispatch(editCar(newData,"Update"));
                  if(newData.driver !== oldData.driver && oldData.driver){
                    dispatch(updateUserCar(oldData.driver,
                      { 
                        carType: null,
                        vehicleNumber: null,
                        vehicleMake: null,
                        vehicleModel: null,
                        other_info: null,
                        car_image: null,
                        updateAt: new Date().getTime()
                      }));
                  }
                }
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 600);
            }),
          onRowDelete: oldData =>
            settings.AllowCriticalEditsAdmin?
            new Promise((resolve, reject) => {
              setTimeout(() => {
                if(oldData.active){
                    reject();
                    alert(t('active_car_delete'));
                } else {
                    resolve();
                    dispatch(editCar(oldData,"Delete"));
                }
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 600);
            })
        }}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
      <Grid container spacing={1} className={classes.paper} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
                {t('car_image')}
              <input
                  type="file"
                  style={{marginLeft:10}}
                  name= {t('image')}
                  onChange={(event) => {
                      setSelectedImage(event.target.files[0]);
                  }}
              />
            </Typography>
         </Grid>
         <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage  && !loading ? 
                    <Tooltip title={t('cancel')}>
                      <CancelIcon onClick={()=>setSelectedImage(null)} style={{ fontSize: 30,backgroundColor:'#1a1a1a',borderRadius:50,color:'#ffffff' }}  />
                    </Tooltip>
                  : null }
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage ? 
                   <img alt="not fount" width={"200px"} height={"200px"}  src={URL.createObjectURL(selectedImage)} style={{marginTop:15,marginBottom:20}}/>
                   :
                    <img alt="not fount" width={"200px"} height={"200px"}  src={imageData} style={{marginTop:10}}/>
                  }
                <br />
                </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          {loading ? 
            <Grid
              container
              spacing={0}
              alignItems="center"
              justify="center"
              style={{ minHeight: '5vh' }} >
              <CircularProgress/>
            </Grid>
            :
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            <Button onClick={handleProfileModal} variant="contained" color="danger">
              {t('cancel')}
            </Button>
            <Button onClick={handleSetProfileModal} variant="contained" color="secondaryButton" style={{marginLeft:10}}>
              {t('save')}
            </Button>
            </Grid>
          }
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>
  );
}
